import { registerPlugin } from '@capacitor/core';
const ZebraPDA = registerPlugin('ZebraPDA', {
    web: () => import('./web').then(m => new m.ZebraPDAWeb()),
});
export * from './definitions';
export { ZebraPDA };
//# sourceMappingURL=index.js.map